import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { getDisplayName } from '@bingads-webui-react/hoc-utils';
import { RECOMMENDATION_CATEGORIES_IDS, RECOMMENDATION_CATEGORIES } from '../consts';

function filterData({ data, filterCategory, recommendationCustomizedDataFilterFunc }) {
  if (_.isFunction(recommendationCustomizedDataFilterFunc)) {
    return recommendationCustomizedDataFilterFunc(data);
  }
  if (filterCategory &&
    filterCategory !== RECOMMENDATION_CATEGORIES_IDS[RECOMMENDATION_CATEGORIES.ALL]) {
    const matcher = _.matcher({ category: filterCategory });
    return _.pick(data, matcher);
  }

  return data;
}

export const withFilterCategory = (WrappedComponent) => {
  const HoC = props => (
    <WrappedComponent
      {...props}
      data={filterData(props)}
    />
  );

  HoC.displayName = `withFilterCategory(${getDisplayName(WrappedComponent)})`;
  HoC.propTypes = {
    filterCategory: PropTypes.string,
    data: PropTypes.objectOf(PropTypes.any),
  };
  HoC.defaultProps = {
    filterCategory: null,
    data: null,
  };

  hoistNonReactStatics(HoC, WrappedComponent);

  return HoC;
};
